import { render } from "./ButtonDeleteComponent.vue?vue&type=template&id=52248719"
import script from "./ButtonDeleteComponent.vue?vue&type=script&lang=js"
export * from "./ButtonDeleteComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__